import register from '../../../../global/js/registry';
export default register('m-product-gallery', () => import(/* webpackMode: "lazy" */ './m-product-gallery.controller'));
